import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 mt-12">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Logo et description */}
          <div className="md:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <img 
                src="https://static.prod-images.emergentagent.com/jobs/9643cc96-b86f-4efa-8d80-b37b546d9b1f/images/2fd5ab3b44fa3f4907d93728c24de30513411ee13e80ef5a6d9f68b4b7962ca6.png" 
                alt="123Pariez"
                className="h-8 brightness-0 invert"
              />
            </Link>
            <p className="text-sm text-gray-400">
              Comparateur indépendant des meilleurs sites de paris sportifs agréés en France.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-white font-semibold mb-4">Navigation</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-white transition-colors">Accueil</Link></li>
              <li><Link to="/sites-paris" className="hover:text-white transition-colors">Sites de Paris</Link></li>
              <li><Link to="/bonus" className="hover:text-white transition-colors">Bonus</Link></li>
              <li><Link to="/guides" className="hover:text-white transition-colors">Guides</Link></li>
              <li><Link to="/pronostics" className="hover:text-white transition-colors">Pronostics</Link></li>
            </ul>
          </div>

          {/* Légal */}
          <div>
            <h3 className="text-white font-semibold mb-4">Informations légales</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/mentions-legales" className="hover:text-white transition-colors">Mentions légales</Link></li>
              <li><Link to="/politique-confidentialite" className="hover:text-white transition-colors">Politique de confidentialité</Link></li>
              <li><Link to="/disclaimer" className="hover:text-white transition-colors">Disclaimer</Link></li>
            </ul>
          </div>

          {/* Jeu responsable */}
          <div>
            <h3 className="text-white font-semibold mb-4">Jeu responsable</h3>
            <p className="text-sm text-gray-400 mb-3">
              Les jeux d'argent sont interdits aux mineurs.
            </p>
            <div className="flex items-center space-x-2 mb-3">
              <span className="bg-red-600 text-white text-xs px-2 py-1 rounded font-bold">18+</span>
              <span className="text-xs text-gray-400">Jouez responsable</span>
            </div>
            <p className="text-xs text-gray-500">
              Joueurs Info Service : 09 74 75 13 13 (appel non surtaxé)
            </p>
          </div>
        </div>

        {/* Séparateur */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-500">
            <p>© 2025 123pariez.com - Tous droits réservés</p>
            <p className="mt-2 md:mt-0">
              Édité par <strong>OPTIMHUB</strong> - SIREN 534 057 088
            </p>
          </div>
          <p className="text-xs text-gray-600 mt-4 text-center">
            Les informations présentées sur ce site sont fournies à titre indicatif. 
            Consultez les sites des opérateurs pour les conditions exactes des offres.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
